/*
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import {
  type SEARCH_BAR_CLICK,
  type ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK,
  type ZOE_ENTRY_CLICK,
  type ZOE_ENTRY_FILTER_BAR_CLICK,
  type ZOE_ENTRY_IMPRESSION,
  type ZOE_ENTRY_SEARCH_BAR_CLICK,
  type ZOE_NO_RESULT,
  type ZOE_SAVED_QUESTION_SUGGESTION_CLICK,
  type ZOE_SEARCH_QUERY_SEND,
  type ZOE_TOGGLE_CLICK,
  event,
} from '@zcode-ui/web-zumper-integrations'
import * as Optimizely from '@zcode/nr/es/shared/packages/optimizely-middleware'
import type { Dispatch, GetState, State } from '@zcode/state-type'

const getCurrentLocation = (state: State) => {
  return state.currentSearch.location
}

export const selectFilters = (state: State) => {
  return state.filters.filters
}

export const trackMapListZoeEvent =
  ({
    eventName,
    additionalProps = {},
  }: {
    eventName:
      | typeof SEARCH_BAR_CLICK
      | typeof ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK
      | typeof ZOE_ENTRY_CLICK
      | typeof ZOE_ENTRY_FILTER_BAR_CLICK
      | typeof ZOE_ENTRY_IMPRESSION
      | typeof ZOE_ENTRY_SEARCH_BAR_CLICK
      | typeof ZOE_NO_RESULT
      | typeof ZOE_SAVED_QUESTION_SUGGESTION_CLICK
      | typeof ZOE_SEARCH_QUERY_SEND
      | typeof ZOE_TOGGLE_CLICK
    additionalProps?: object
  }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const user = getUser(state)
    const location = getCurrentLocation(state)
    const filters = selectFilters(state)

    const props = {
      host: window.location.host,
      url: window.location.href,
      ...additionalProps,
    }

    dispatch(event({ name: eventName, filters, props, user, location }))
    dispatch(Optimizely.track({ eventKey: eventName }))
  }
